import { render, staticRenderFns } from "./LearningGoalsForBlockLink.vue?vue&type=template&id=027677f0&"
import script from "./LearningGoalsForBlockLink.vue?vue&type=script&lang=js&"
export * from "./LearningGoalsForBlockLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports